module.exports = __webpack_public_path__ + "static/img/22.cbe2c6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/22.png
// module id = VvR3
// module chunks = 0